import { render, staticRenderFns } from "./vertical-scrollbar.vue?vue&type=template&id=14402a02"
import script from "./vertical-scrollbar.vue?vue&type=script&lang=js"
export * from "./vertical-scrollbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports